import { SIGMA_CONSTANTS } from "src/app/core/utils/sigma-constants";
import { Options } from "vis-network/peer";
export interface NodeConnectModel {
	id: string;
	idOriginal: number;
	url: string;
	label: string;
}

export interface OptionsNodeConnectModel {
	id: string;
	type: string;
	label: string;
	size: number;
	color: string;
}

export let initialOptions: Options = {
	autoResize : true,

	interaction:{
		dragNodes:true,
		dragView: true,
		hideEdgesOnDrag: false,
		hideEdgesOnZoom: false,
		hideNodesOnDrag: false,
		hover: true,
		hoverConnectedEdges: true,
		keyboard: {
			enabled: true,
			speed: {x: 10, y: 10, zoom: 0.02},
			bindToWindow: false,
			autoFocus: true,
		},
		multiselect: false,
		navigationButtons: false,
		selectable: true,
		selectConnectedEdges: true,
		tooltipDelay: 300,
		zoomSpeed: 1,
		zoomView: false
	},
	manipulation: {
		enabled: false,
	},
	nodes: {
		brokenImage: SIGMA_CONSTANTS.IMAGE_DEFAULT,
		shape: "box",
		size: 20,
		font: {
			size: 15,
			color: "#ffffff",
		},
		borderWidth: 2,
		borderWidthSelected: 3,
		scaling: {
      min: 10,
      max: 30,
      label: {
        enabled: false,
        min: 14,
        max: 30,
        maxVisible: 30,
        drawThreshold: 5
      },
      customScalingFunction: function (min,max,total,value) {
        if (max === min) {
          return 0.5;
        }
        else {
          let scale = 1 / (max - min);
          return Math.max(0,(value - min)*scale);
        }
      }
    }
	},
	edges: {
		color: "#000000",
		width: 2,
		selectionWidth: 0,
		smooth: {
			enabled: true,
			type: "horizontal",
			roundness: 0.1,
		},
		arrowStrikethrough: false,
	},
	groups: {
		diamonds: {
			color: { background: "red", border: "white" },
			shape: "diamond",
		},
		circles: {
			color: { background: "blue", border: "black" },
			shape: "circle",
		},
		dotsWithLabel: {
			label: "I'm a dot!",
			shape: "dot",
			color: "cyan",
		},
		mints: { color: "rgb(0,255,140)" },
		icons: {
			shape: "icon",
			icon: {
				face: "FontAwesome",
				code: "fa-question",
				size: 50,
				color: "red",
			},
		},
		circle_red: {
			shape: "circle",
			color: { background: "red", border: "yellow" },
		},
		images: {
			unselected: SIGMA_CONSTANTS.IMAGE_DEFAULT,
			shape: "circularImage",
		},
		rawImage: {
			shape: "image",
		},
		sticker: {
			shape: "image",
		},
		quiz: {
            shape: "box", // Cambiado de "image" a "box"
            // Esquinas 100% rectas (vis-network aplica ~6px de borderRadius por defecto)
            shapeProperties: { borderRadius: 0 },
            // Desactiva los cambios visuales automáticos al seleccionar/hover — evita el
            // borde azul sticky que se quedaba pegado en las actividades tras drag+click.
            chosen: false,
            borderWidth: 2, // 'borderwidth' a 'borderWidth' (camelCase es más estándar en vis.js)
            borderWidthSelected: 2, // evita que el top-level (3) engorde el borde al seleccionar
            font: {
                color: "red", // Cambiado a rojo
                size: 25,
                face: 'Arial',
                bold: true // Hacemos que sea negrita para que resalte más
            },
            color: {
                border: "#CCCCCC", // Un color de borde por defecto (gris)
                background: "#FFFFFF", // Fondo blanco
            },
        },

	},
	physics: {
		enabled: false,
	},

}
